import React, { useMemo } from 'react';
import { useObjectContext } from '@/hooks/useObjectContext';
import { CreateNoteButton } from '@/components/buttons/viewHeaderButtons/CreateNoteButton';
import { CreateTaskButton } from '@/components/buttons/viewHeaderButtons/CreateTaskButton';
import { CreateRelationshipContactButton } from '@/components/buttons/viewHeaderButtons/CreateRelationshipContactButton';
import { TabView } from '@/components/layouts/TabView';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { getRelationshipCompanyTabs } from '@/app/tabs';
import { ClientBrandIcon } from '@/components/icons/ClientBrandIcon';
import { RelationshipsIcon } from '@/components/icons/RelationshipsIcon';
import { useGetRelationshipCompanyContactData } from '@/hooks/useGetRelationshipCompanyContactData';
import WorkspaceContextProvider from '@/context/WorkspaceContext';

export const RelationshipCompanyTabView = () => {
	const theme = useTheme();
	const location = useLocation();
	const { relationshipCompanyId } = useObjectContext();
	const { logoDomain, subtitle } = useGetRelationshipCompanyContactData();

	const headerComponents = useMemo(
		() => ({
			'': CreateRelationshipContactButton,
			notes: CreateNoteButton,
			tasks: CreateTaskButton,
		}),
		[],
	);

	const tabs = useMemo(() => {
		const pathname = location.pathname.split(`/${relationshipCompanyId}`);
		return getRelationshipCompanyTabs(pathname[0]).map((tab) => ({
			...tab,
			HeaderComponent: headerComponents[tab.value],
		}));
	}, [relationshipCompanyId, headerComponents, location.pathname]);

	const activeTabs = useMemo(() => tabs.filter((tab) => tab.showComponent !== false), [tabs]);

	return (
		<WorkspaceContextProvider>
			<TabView
				objectType='relationshipCompany'
				tabs={activeTabs}
				icon={
					<ClientBrandIcon
						domain={logoDomain}
						height='55px'
						width='55px'
						fallbackIcon={
							<RelationshipsIcon
								width='55px'
								height='55px'
								{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
							/>
						}
					/>
				}
				subtitle={subtitle}
			/>
		</WorkspaceContextProvider>
	);
};
